import * as React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Accounts() {
    const [inputValue, setInputValue] = React.useState('');
    const navigate = useNavigate();
    
      const handleSubmit = (e) => {
        e.preventDefault();
        navigate({pathname: `${inputValue}`})
        setInputValue("")
      };

    return(
        <Container>
            <Row>
                <Col xs={{ span: 6, offset: 3 }}>
                    <Form onSubmit={handleSubmit} >
                    <InputGroup className="mb-3">
                        <Form.Control
                        required
                        placeholder="Account ID"
                        aria-label="Account ID"
                        aria-describedby="input-desc"
                        onChange={(e) => setInputValue(e.target.value)}
                        value={inputValue}
                        />
                        <Button type="submit" variant="success" id="account-submit-btn">
                            Look Up
                        </Button>

                    </InputGroup>
                    </Form>

                </Col>
            </Row>

            <Outlet />
      </Container>
    )
}

export default Accounts